module.exports = __webpack_public_path__ + "img/bgblue.62538ecc.png";